import React, { useEffect, useState } from 'react';
import DeleteIcon from '../components/Icons/DeleteIcon';
import RankRumbleIcon from '../components/Icons/RankRumbleIcon';
import DuplicateRumbleIcon from '../components/Icons/DuplicateRumbleIcon';
import ExportRumbleDataIcon from '../components/Icons/ExportRumbleDataIcon';
import ResultsRumbleIcon from '../components/Icons/ResultsRumbleIcon';
import ShareRumbleIcon from '../components/Icons/ShareRumbleIcon';
import EmptyRumblesListIcon from '../components/Icons/EmptyRumblesListIcon';
import { Link } from 'react-router-dom';
import GetUnlimited from '../components/GetUnlimited/GetUnlimited';
import Input from '../components/Input/Input';
import PageHeader from '../components/PageHeader/PageHeader';
import RumbleItem from '../types/RumbleItem';
import RumbleList from '../types/RumbleList';
import CustomModal from '../components/CustomModal/CustomModal';
import Label from '../components/Label/Label';
import ShareCopyIcon from '../components/Icons/ShareCopyIcon';
import ShareCopyDoneIcon from '../components/Icons/ShareCopyDoneIcon';
import QrCodeWithDownload from '../components/QrCodeWithDownload';
import CloseModalIcon from '../components/Icons/CloseModalIcon';
import Button from '../components/Button/Button';
import Participant from '../types/Participant';

interface IDashboard {
  props: any;
  logOutModal: (params: boolean) => void;
  editModal: (params: boolean) => void;
  resultsModal: (params: boolean) => void;
  videoModal: (params: boolean) => void;
  upgradeModal: (params: boolean) => void;
  isEditOpen: boolean;
  isFullOpen: boolean;
  isResultsOpen: boolean;
  resultsRumbleID: (params: number) => void;
  duplicateRumbleID: (params: number) => void;
  isMobile: boolean;
}
export default function Dashboard({
  props,
  logOutModal,
  editModal,
  resultsModal,
  videoModal,
  upgradeModal,
  isEditOpen,
  isFullOpen,
  isResultsOpen,
  resultsRumbleID,
  duplicateRumbleID,
  isMobile,
}: IDashboard) {
  const [lists, setLists] = useState<any>();
  const [listItem, setListItem] = useState(null as RumbleList | null);
  const [listItemParticipants, setListItemParticipants] = useState(
    [] as Participant[] | null
  );
  const [isShareOpen, setIsShareOpen] = useState(false);
  const [isDeleteOpen, setIsDeleteOpen] = useState(false);
  const [deleteItem, setDeleteItem] = useState(null as RumbleItem | null);
  const [resultsRumbleName, setResultsRumbleName] = useState('');
  const [isCopied, setIsCopied] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  const [searchValue, setSearchValue] = useState('');
  function getList() {
    fetch('/api/RumbleLists')
      .then((resp) => resp.json())
      .then((json) => {
        setLists(json);
      });
  }
  function getListItem(listId: number) {
    fetch(`/api/RumbleLists/${listId}`)
      .then((resp) => resp.json())
      .then((json) => {
        setListItem(json);
      });
    fetch(`/api/RumbleLists/${listId}/Participants`)
      .then((resp) => resp.json())
      .then((json) => {
        setListItemParticipants(json);
      });
  }
  useEffect(() => {
    getList();
  }, []);
  function shareRumble(listId: number) {
    setIsShareOpen(true);

    getListItem(listId);
  }

  function copyListLink() {
    let copyButton = document.getElementById('copyButton') as HTMLButtonElement;
    let listLink = document.getElementById('listLink') as HTMLInputElement;
    setIsCopied(true);
    listLink.disabled = false;
    listLink.focus();
    listLink.select();
    listLink.setSelectionRange(0, 9999);
    document.execCommand('copy');
    listLink.disabled = true;
    listLink.setSelectionRange(0, 0);
    listLink.blur();
    copyButton.disabled = true;
    setTimeout(resetCopyButton, 2000);
  }
  function closeShareModal() {
    setListItem(null);
    setListItemParticipants(null);
    setIsShareOpen(false);
  }

  function openDeleteModal(item: RumbleItem) {
    setIsDeleteOpen(true);
    setDeleteItem(item);
  }
  function closeDeleteModal() {
    setIsDeleteOpen(false);
    setDeleteItem(null);
  }

  function resetCopyButton() {
    let copyButton = document.getElementById('copyButton') as HTMLButtonElement;
    copyButton.disabled = false;
    setIsCopied(false);
  }
  function deleteList(listId: number) {
    setIsDeleting(true);
    fetch(`/api/RumbleLists/${listId}`, {
      method: 'DELETE',
    }).then(() => {
      getList();
      closeDeleteModal();
      setIsDeleting(false);
    });
  }
  return (
    <>
      <PageHeader
        props={props}
        title={'Manage your Rumbles'}
        logOutModal={logOutModal}
        editModal={editModal}
        resultsModal={resultsModal}
        isEditOpen={isEditOpen}
        isFullOpen={isFullOpen}
        isResultsOpen={isResultsOpen}
        resultsTitle={resultsRumbleName}
      >
        <div
          className={
            'max-tablet:flex max-tablet:flex-col max-tablet:gap-4 max-tablet:mb-4'
          }
        >
          <Input
            variant={'search'}
            placeholder={'Search by name...'}
            onChange={(e) => setSearchValue(e.target.value)}
          />
          {props.user?.subscriptionTier === 'Free' && isMobile ? (
            <GetUnlimited variant={'page'} upgradeModal={upgradeModal} />
          ) : null}
        </div>
      </PageHeader>
      <div className={'container tablet:pt-32'}>
        {lists ? (
          lists.length ? (
            <div
              className={
                'grid grid-cols-2 max-[700px]:grid-cols-1 tablet:grid-cols-1 min-[1024px]:grid-cols-2 desktop:grid-cols-3 gap-6 max-tablet:gap-4'
              }
            >
              {lists
                .filter((l: RumbleItem) => {
                  if (!searchValue) return true;
                  return l.name.includes(searchValue);
                })
                .map((l: RumbleItem) => {
                  return (
                    <div
                      key={l.id}
                      className={
                        'text-primary p-4 rounded-8 shadow-xs flex flex-col gap-4'
                      }
                    >
                      <div
                        className={'flex gap-4 items-center justify-between'}
                      >
                        <p
                          className={
                            'text-primary text-16 largeTablet:text-20 leading-140 font-semibold'
                          }
                        >
                          {l.name}
                        </p>
                        <button
                          type={'button'}
                          onClick={() => openDeleteModal(l)}
                        >
                          <DeleteIcon />
                        </button>
                      </div>
                      <img
                        src={
                          l.imageURL ? l.imageURL : 'img/imagePlaceHolder.jpg'
                        }
                        className={
                          'object-cover w-full aspect-[311/160] rounded-6'
                        }
                        alt={`Thumbnail for ${l.name}`}
                        loading={'eager'}
                      />
                      <div
                        className={
                          'flex gap-4 smallMobile:items-center justify-between max-smallMobile:flex-col'
                        }
                      >
                        <Link
                          to={`/share/${l.id}`}
                          type={'button'}
                          className={
                            'text-12 largeTablet:text-base font-semibold text-blue flex gap-2 items-center'
                          }
                        >
                          <RankRumbleIcon />
                          Rank it yourself
                        </Link>
                        <Link
                          className={
                            'text-12 largeTablet:text-base font-semibold text-green flex gap-2 items-center'
                          }
                          to={`/create`}
                          onClick={() => duplicateRumbleID(l.id)}
                        >
                          <DuplicateRumbleIcon />
                          Duplicate Rumble
                        </Link>
                      </div>
                      <hr className={'border-t border-borderColor'} />
                      <div
                        className={
                          'flex gap-2 smallMobile:items-center justify-between max-smallMobile:flex-col'
                        }
                      >
                        <a
                          className={
                            'text-12 largeTablet:text-13 flex gap-2 items-center'
                          }
                          href={`/api/DataExport/${l.id}`}
                        >
                          <ExportRumbleDataIcon />
                          Export data
                        </a>
                        <button
                          type={'button'}
                          className={
                            'text-12 largeTablet:text-13 flex gap-2 items-center'
                          }
                          onClick={() => {
                            resultsRumbleID(l.id);
                            setResultsRumbleName(l.name);
                            resultsModal(true);
                          }}
                        >
                          <ResultsRumbleIcon />
                          Results
                        </button>
                        <button
                          type={'button'}
                          className={
                            'text-12 largeTablet:text-13 flex gap-2 items-center'
                          }
                          onClick={() => shareRumble(l.id)}
                        >
                          <ShareRumbleIcon />
                          Share Rumble
                        </button>
                      </div>
                    </div>
                  );
                })}
            </div>
          ) : (
            <div className={'max-w-[340px] mx-auto pt-36 max-tablet:py-10'}>
              <div
                className={
                  'flex justify-center max-tablet:max-w-[263px] mx-auto mb-10 max-tablet:mb-8'
                }
              >
                <EmptyRumblesListIcon />
              </div>
              <p
                className={
                  'text-primary text-center text-18 max-tablet:text-16 leading-155 mb-6 max-tablet:mb-2 max-tablet:max-w-[222px] mx-auto'
                }
              >
                You didn't created any Rumble game yet
              </p>
              <Button
                variant={'primary'}
                className={'text-16 uppercase py-2.5 px-8 w-full'}
                onClick={() => videoModal(true)}
              >
                How to use RumbleRank?
              </Button>
            </div>
          )
        ) : (
          <p className={'text-primary text-center'}>Loading...</p>
        )}
      </div>
      <CustomModal
        isOpen={isShareOpen}
        isClose={closeShareModal}
        variant={'share'}
      >
        <div className={'flex flex-col gap-4'}>
          {listItem ? (
            listItem.type === 'Open' ? (
              <>
                <p className={'text-primary text-16 leading-150 font-semibold'}>
                  Your Rumble has been created!
                </p>
                <div>
                  <Label
                    htmlFor={'listLink'}
                    text={'Link to share this Rumble:'}
                  />
                  <div className={'relative'}>
                    <Input
                      id={'listLink'}
                      variant={'text'}
                      value={`${process.env['REACT_APP_BASE_URL']}/share/${listItem.id}`}
                      className={'pr-11'}
                      disabled
                    />
                    <button
                      className={
                        'absolute right-0 h-full top-0 flex items-center justify-center px-3'
                      }
                      type={'button'}
                      id={'copyButton'}
                      onClick={copyListLink}
                    >
                      {isCopied ? <ShareCopyDoneIcon /> : <ShareCopyIcon />}
                    </button>
                  </div>
                </div>
                <QrCodeWithDownload
                  content={`${process.env['REACT_APP_BASE_URL']}/share/${listItem.id}`}
                  fileName={`RumbleRank_${listItem.name.replace(
                    /[^\w]/g,
                    '_'
                  )}_QR.png`}
                  close={closeShareModal}
                />
              </>
            ) : (
              <>
                <div className={'flex items-center justify-between gap-5 mb-4'}>
                  <p
                    className={'text-primary text-20 leading-140 font-semibold'}
                  >
                    Participant List
                  </p>
                  <button type={'button'} onClick={closeShareModal}>
                    <CloseModalIcon />
                  </button>
                </div>
                <div className={'flex flex-col gap-3'}>
                  {listItemParticipants &&
                    listItemParticipants.map((ItemParticipant) => (
                      <p
                        key={listItemParticipants.indexOf(ItemParticipant)}
                        className={'text-primary text-16'}
                      >
                        {ItemParticipant.emailAddress}
                      </p>
                    ))}
                </div>
              </>
            )
          ) : (
            <p className={'text-center text-primary text-16 leading-150'}>
              Loading...
            </p>
          )}
        </div>
      </CustomModal>
      <CustomModal
        isOpen={isDeleteOpen}
        isClose={closeDeleteModal}
        variant={'delete'}
      >
        <div className={'flex flex-col gap-4'}>
          {deleteItem && (
            <>
              <div className={'flex items-center justify-between gap-5'}>
                <p className={'text-primary text-20 leading-140 font-semibold'}>
                  Delete {deleteItem.name}
                </p>
                <button type={'button'} onClick={closeDeleteModal}>
                  <CloseModalIcon />
                </button>
              </div>
              <p className={'text-primary text-base leading-171'}>
                Are you sure you want to delete {deleteItem.name}? It will be
                gone forever!
              </p>
              <div className={'grid grid-cols-2 gap-3'}>
                <Button variant={'secondary'} onClick={closeDeleteModal}>
                  Cancel
                </Button>
                <Button
                  variant={'delete'}
                  onClick={() => deleteList(deleteItem.id)}
                  disabled={isDeleting}
                >
                  {isDeleting ? 'Deleting...' : 'Delete rumble'}
                </Button>
              </div>
            </>
          )}
        </div>
      </CustomModal>
    </>
  );
}
